"use client";
import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";

import { MINDSET_JAIL_PHONE_NUMBER } from "@/lib/constants";
import Link from "next/link";
import { formatPhoneNumber } from "@/utils/helpers";
import { MINDSET_PHONE_NUMBER } from "@/lib/constants";

export default function PrequalNotQualified({
  isJailUser,
}: {
  isJailUser?: boolean;
}) {
  return (
    <VStack flex="1" h="100vh" justifyContent="center">
      <Box
        textAlign="center"
        borderWidth="1px"
        borderColor="#E4E4E4"
        p="24px"
        mr="24px"
        ml="24px"
        borderRadius="4px"
        mt={{
          base: "24px",
          md: "0px",
        }}
      >
        <Heading
          textAlign="center"
          as="h2"
          fontSize="32px"
          fontWeight="800"
          color="brand.secondary"
          mb="20px"
        >
          We’re sorry. You don’t qualify for Mindset services at this time.{" "}
        </Heading>
        <Text mb="20px">
          Unfortunately, Mindset is only able to serve people in certain
          situations. This doesn’t mean you are not eligible for SSI or SSDI, so
          we encourage you to reach out to Social Security at{" "}
          {isJailUser ? (
            "ssa.gov/disability."
          ) : (
            <Link href="https://www.ssa.gov/disability" target="_blank">
              <strong>ssa.gov/disability.</strong>{" "}
            </Link>
          )}
        </Text>
        <Text>
          If you think there has been a mistake, you{" "}
          {isJailUser ? (
            `can call us at ${formatPhoneNumber(MINDSET_JAIL_PHONE_NUMBER)}`
          ) : (
            <Button
              as={Link}
              href={`tel:${MINDSET_PHONE_NUMBER}`}
              height="50px"
              color="brand.secondary"
              fontSize="16px"
              margin="0px"
              marginTop="-3px"
              padding="0px"
              fontWeight="700"
              borderWidth="0px"
              borderColor="brand.secondary"
              bg="transparent"
              _hover={{
                textDecoration: "none",
              }}
            >
              <strong>
                can call us at {formatPhoneNumber(MINDSET_PHONE_NUMBER)}{" "}
              </strong>
            </Button>
          )}
        </Text>
      </Box>
    </VStack>
  );
}
